import * as React from 'react';
import { Card, Col, Form, Row, Container, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { getCountries, getState, getcity } from "../../api/studentDetails";

function AddressDetails({ formData, setFormData, handleChange, onSubmit, errors, setErrors, isEditMode }) {
    const [error, setError] = useState('');
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [countryRes] = await Promise.all([
                    getCountries(token),
                ]);
                setFormData((prevData) => ({
                    ...prevData,
                    countryid: countryRes.data
                }));
            } catch (error) {
                setError("Error fetching data:", error);

            }
        };
        fetchInitialData();
    }, [token]);

    useEffect(() => {
        if (formData.permanent.selectedCountry) {  
            const fetchStates = async () => {
                try {
                    const stateRes = await getState(token, formData.permanent.selectedCountry);
                    setFormData((prevData) => ({
                        ...prevData,
                        stateid: stateRes.data
                    }));
                } catch (error) {
                    setError("Error fetching states:", error);
                }
            };
            fetchStates();
        }
    }, [formData.permanent.selectedCountry, token]);

    useEffect(() => {
        if (formData.permanent.selectedState) {
            const fetchcities = async () => {
                try {
                    const cityRes = await getcity(token, formData.permanent.selectedState);
                    setFormData((prevData) => ({
                        ...prevData,
                        cityid: cityRes.data
                    }));
                } catch (error) {
                    setError("Error fetching states:", error);
                }
            };
            fetchcities();
        }
    }, [formData.permanent.selectedState, token]);


    const handleCheckboxChange = () => {
        const isSame = !formData.temporary.sameAsPermanent;

        
        const updatedTemporary = isSame
            ? {
                country: formData.permanent.selectedCountry,
                currentAddress: formData.permanent.permanentAddress,
                state: formData.permanent.selectedState,
                currentTaluka: formData.permanent.permanentTaluka,
                currentPinCode: formData.permanent.permanentPinCode,
                city: formData.permanent.selectedCity
            }
            : {
                country: '',
                permanentAddress: '',
                state: '',
                taluka: '',
                pinCode: '',
                city: ''
            };

        setFormData((prevData) => ({
            ...prevData,
            temporary: {
                ...prevData.temporary,
                sameAsPermanent: isSame,
                ...updatedTemporary,
            }
        }));
    };

    const validateAddressField = (fieldName, value) => {
        const fieldValidations = {
            'permanent.permanentPinCode': value => {
                if (!value) return 'Pin Code is required';
                if (!/^\d+$/.test(value)) return 'Only numeric values allowed';
                if (value.length !== 6) return 'Pin Code must be 6 digits';
                return '';
            },
            'temporary.currentPinCode': value => {
                if (!value) return 'Pin Code is required';
                if (!/^\d+$/.test(value)) return 'Only numeric values allowed';
                if (value.length !== 6) return 'Pin Code must be 6 digits';
                return '';
            },
            'permanent.permanentAddress': value => {
                if (!value) return 'Address is required';
                if (/^\d+$/.test(value.trim())) return 'Only numeric values not allowed';
                if (!/^[a-zA-Z0-9\s,.-]*$/.test(value)) return 'Only alphanumeric characters and basic punctuation allowed';
                return '';
            },

            'temporary.currentAddress': value => {
                 if (!value) return 'Address is required';
                if (/^\d+$/.test(value.trim())) return 'Only numeric values not allowed';
                if (!/^[a-zA-Z0-9\s,.-]*$/.test(value)) return 'Only alphanumeric characters and basic punctuation allowed';
                return '';
            }
        };

        return fieldValidations[fieldName] ? fieldValidations[fieldName](value) : '';
    };

    const handleFieldChange = (section, fieldName, value) => {
        handleChange(section, fieldName, value);

        const fullFieldName = section ? `${section}.${fieldName}` : fieldName;
        const errorMsg = validateAddressField(fullFieldName, value);

        setErrors(prev => ({
            ...prev,
            addressDetails: {
                ...prev.addressDetails,
                [fullFieldName]: errorMsg
            }
        }));
    };


    return (

        <>
            <Container fluid>
                <Row className="mt-4" >
                    <Col>
                        <Card >
                            <Card.Body>
                                <div>
                                    <Form>
                                        <Form.Label style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}
                                            className='mb-3  mt-2'>Permanent Address</Form.Label>
                                        <Row>
                                            <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                <Row className="mb-2">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Country <span className="text-danger">*</span></Form.Label>
                                                        <Form.Select type="text"
                                                            id="selectedCountry" required
                                                            name='selectedCountry'
                                                            value={formData.permanent.selectedCountry}
                                                            onChange={(e) => handleFieldChange('permanent', 'selectedCountry', e.target.value)} >

                                                            <option>Select Country</option>
                                                            {formData.countryid.map((country) =>
                                                                <option key={country.id} value={country.id}>
                                                                    {country.name}
                                                                </option>)}
                                                        </Form.Select>
                                                        {errors?.["permanent.selectedCountry"] && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors["permanent.selectedCountry"]}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Taluka </Form.Label>
                                                        <Form.Control type="text" placeholder="Enter Taluka"
                                                            id="permanentTaluka" required
                                                            name='permanentTaluka'
                                                            value={formData.permanent.permanentTaluka}
                                                            onChange={(e) => handleFieldChange('permanent', 'permanentTaluka', e.target.value)} />
                                                        {errors?.["permanent.permanentTaluka"] && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors["permanent.permanentTaluka"]}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Row>


                                            </Col>

                                            <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                <Row className="mb-2">
                                                    <Form.Group className="mb-2" >
                                                        <Form.Label>State<span className="text-danger">*</span></Form.Label>
                                                        <Form.Select type="text"
                                                            id="selectedState" required
                                                            name='selectedState'
                                                            value={formData.permanent.selectedState}
                                                            onChange={(e) => handleFieldChange('permanent', 'selectedState', e.target.value)} >
                                                            <option>Select State</option>
                                                            {formData.stateid.map((state) =>
                                                                <option key={state.id} value={state.id}>
                                                                    {state.name}
                                                                </option>)}
                                                        </Form.Select>
                                                        {errors?.["permanent.selectedState"] && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors["permanent.selectedState"]}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Row>

                                                <Row className="mb-2">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Permenant Address<span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control type="text" placeholder="Enter Permenant Address"
                                                            id="permanentAddress" required
                                                            name='permanentAddress'
                                                            value={formData.permanent.permanentAddress}
                                                            onChange={(e) => handleFieldChange('permanent', 'permanentAddress', e.target.value)} />
                                                        {errors?.["permanent.permanentAddress"] && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors["permanent.permanentAddress"]}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Row>
                                            </Col>
                                            <Col>
                                                <Row className="mb-2">
                                                    <Form.Group className="mb-2" >
                                                        <Form.Label>Pin Code<span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control type="text" placeholder='Enter Pincode'
                                                            id="permanentPinCode" required
                                                            name='permanentPinCode'
                                                            value={formData.permanent.permanentPinCode}
                                                            onChange={(e) => handleFieldChange('permanent', 'permanentPinCode', e.target.value)} />
                                                        {errors?.["permanent.permanentPinCode"] && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors["permanent.permanentPinCode"]}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Row>
                                            </Col>
                                            <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                <Row className="mb-2">
                                                    <Form.Group className="mb-2" >
                                                        <Form.Label>City <span className="text-danger">*</span></Form.Label>
                                                        <Form.Select type="text"
                                                            id="selectedCity" required
                                                            name='selectedCity'
                                                            value={formData.permanent.selectedCity}
                                                            onChange={(e) => handleFieldChange('permanent', 'selectedCity', e.target.value)} >
                                                            <option>Select City</option>
                                                            {formData.cityid.map((city) =>
                                                                <option key={city.id} value={city.id}>
                                                                    {city.name}
                                                                </option>)}
                                                        </Form.Select>
                                                        {errors?.["permanent.selectedCity"] && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors["permanent.selectedCity"]}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Row>

                                            </Col>
                                        </Row>

                                        <Form.Label style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }} className='mt-2'>Temporary Address</Form.Label>
                                        <Row className='mb-3'>
                                            <Col md={9} xs={12}>
                                                <Form.Check
                                                    type="switch"
                                                    id="sameAsPermanent"
                                                    onChange={handleCheckboxChange}
                                                    checked={formData.temporary.sameAsPermanent}
                                                    label="Same as Permanent Address"
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                <Row className="mb-2">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Country <span className="text-danger">*</span></Form.Label>
                                                        <Form.Select type="text"
                                                            id="country" required
                                                            name='country'
                                                            value={formData.temporary.country}
                                                            onChange={(e) => handleFieldChange('temporary', 'country', e.target.value)} >

                                                            <option>Select Country</option>
                                                            {formData.countryid.map((country) =>
                                                                <option key={country.id} value={country.id}>
                                                                    {country.name}
                                                                </option>)}
                                                        </Form.Select>
                                                        {errors?.["temporary.country"] && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors["temporary.country"]}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Taluka </Form.Label>
                                                        <Form.Control type="text" placeholder="Enter Taluka"
                                                            id="currentTaluka" required
                                                            name='currentTaluka'
                                                            value={formData.temporary.currentTaluka}
                                                            onChange={(e) => handleFieldChange('temporary', 'currentTaluka', e.target.value)}
                                                            disabled={formData.temporary.sameAsPermanent} />
                                                        {errors?.["temporary.currentTaluka"] && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors["temporary.currentTaluka"]}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Row>


                                            </Col>

                                            <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                <Row className="mb-2">
                                                    <Form.Group className="mb-2" >
                                                        <Form.Label>State<span className="text-danger">*</span></Form.Label>
                                                        <Form.Select type="text"
                                                            id="state" required
                                                            name='state'
                                                            value={formData.temporary.state}
                                                            onChange={(e) => handleFieldChange('temporary', 'state', e.target.value)}
                                                            disabled={formData.temporary.sameAsPermanent} >
                                                            <option>Select State</option>
                                                            {formData.stateid.map((state) =>
                                                                <option key={state.id} value={state.id}>
                                                                    {state.name}
                                                                </option>)}
                                                        </Form.Select>
                                                        {errors?.["temporary.state"] && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors["temporary.state"]}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Row>

                                                <Row className="mb-2">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Permenant Address<span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control type="text" placeholder="Enter Permenant Address"
                                                            id="currentAddress" required
                                                            name='currentAddress'
                                                            value={formData.temporary.currentAddress}
                                                            onChange={(e) => handleFieldChange('temporary', 'currentAddress', e.target.value)}
                                                            disabled={formData.temporary.sameAsPermanent} />
                                                        {errors?.["temporary.currentAddress"] && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors["temporary.currentAddress"]}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Row>
                                            </Col>

                                            <Col xl={3} lg={3} md={3} xs={12} s={12}>


                                                <Row className="mb-2">
                                                    <Form.Group className="mb-2" >
                                                        <Form.Label>Pin Code<span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control type="text" placeholder='Enter Pincode'
                                                            id="currentPinCode" required
                                                            name='currentPinCode'
                                                            value={formData.temporary.currentPinCode}
                                                            onChange={(e) => handleFieldChange('temporary', 'currentPinCode', e.target.value)}
                                                            disabled={formData.temporary.sameAsPermanent} />
                                                        {errors?.["temporary.currentPinCode"] && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors["temporary.currentPinCode"]}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Row>
                                            </Col>
                                            <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                <Row className="mb-2">
                                                    <Form.Group className="mb-2" >
                                                        <Form.Label>City <span className="text-danger">*</span></Form.Label>
                                                        <Form.Select type="text"
                                                            id="city" required
                                                            name='city'
                                                            value={formData.temporary.city}
                                                            onChange={(e) => handleFieldChange('temporary', 'city', e.target.value)}
                                                            disabled={formData.temporary.sameAsPermanent} >
                                                            <option>Select City</option>
                                                            {formData.cityid.map((city) =>
                                                                <option key={city.id} value={city.id}>
                                                                    {city.name}
                                                                </option>)}
                                                        </Form.Select>
                                                        {errors?.["temporary.city"] && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors["temporary.city"]}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Row>
                                            </Col>
                                            <Row>
                                                <Col className="d-flex align-items-center justify-content-center mb-3 mt-4">
                                                    <Button variant="primary" type="button" onClick={onSubmit}
                                                    >
                                                       {isEditMode ? 'Update' : 'Save'}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Row>
                                    </Form>

                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

        </>

    );
};

AddressDetails.propTypes = {
    formData: PropTypes.shape({
        permanent: PropTypes.shape({
            country: PropTypes.string,
            permanentAddress: PropTypes.string,
            state: PropTypes.string,
            // district: PropTypes.string,
            permanentTaluka: PropTypes.string,
            permanentPinCode: PropTypes.string,
            city: PropTypes.string,
        }).isRequired,
        temporary: PropTypes.shape({
            sameAsPermanent: PropTypes.bool.isRequired,
            country: PropTypes.string,
            permanentAddress: PropTypes.string,
            state: PropTypes.string,
            // district: PropTypes.string,
            taluka: PropTypes.string,
            pinCode: PropTypes.string,
            city: PropTypes.string,
        }).isRequired,
    }).isRequired,
    setFormData: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
};


export default AddressDetails;